var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClipboardWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 10H7.33333V11.3333H2.66667V10ZM2.66667 7.33334H9.33333V8.66667H2.66667V7.33334ZM2.66667 4.66667H9.33333V6H2.66667V4.66667ZM10.6667 2.00001H7.88C7.6 1.22667 6.86667 0.666672 6 0.666672C5.13333 0.666672 4.4 1.22667 4.12 2.00001H1.33333C1.24 2.00001 1.15333 2.00667 1.06667 2.02667C0.806667 2.08 0.573333 2.21334 0.393333 2.39334C0.273333 2.51334 0.173333 2.66 0.106667 2.82C0.0400001 2.97334 0 3.14667 0 3.33334V12.6667C0 12.8467 0.0400001 13.0267 0.106667 13.1867C0.173333 13.3467 0.273333 13.4867 0.393333 13.6133C0.573333 13.7933 0.806667 13.9267 1.06667 13.98C1.15333 13.9933 1.24 14 1.33333 14H10.6667C11.4 14 12 13.4 12 12.6667V3.33334C12 2.6 11.4 2.00001 10.6667 2.00001ZM6 1.83334C6.27333 1.83334 6.5 2.06001 6.5 2.33334C6.5 2.60667 6.27333 2.83334 6 2.83334C5.72667 2.83334 5.5 2.60667 5.5 2.33334C5.5 2.06001 5.72667 1.83334 6 1.83334ZM10.6667 12.6667H1.33333V3.33334H10.6667V12.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClipboardWhite);
export default __webpack_public_path__ + "static/media/icon_clipboard_white.302ba1a5a8045f0acaf8e6fb272fe081.svg";
export { ForwardRef as ReactComponent };